import axios from 'axios'
import { isBrowser, isMobileOnly, isMobile, isTablet } from 'react-device-detect'

export function createAnalyticsItemView(itemType,itemId) {
  return (dispatch, getState) => {
    let userInterface = 'web_panorama_'
    if (isMobileOnly) {
      userInterface += 'mobile'
    } else if (isTablet) {
      userInterface += 'tablet'
    } else if (isBrowser) {
      userInterface += 'desktop'
    }
    const screenDims = [window.screen.width, window.screen.height]
    const screenResolution = (isMobile) ?
      `${Math.min(...screenDims)}x${Math.max(...screenDims)}` :
      `${Math.max(...screenDims)}x${Math.min(...screenDims)}`
    const screenOrientation = (window.screen.height > window.screen.width) ?
      'portrait' :
      'landscape'
    const params = {
      user_interface: userInterface,
      origin_url: window.location.href,
      item_type: itemType,
      screen_resolution: screenResolution,
      screen_orientation: screenOrientation,
      [`${itemType}_id`]: itemId,
    }
    dispatch({
      type: 'ANALYTICS_ITEM_VIEW_CREATE',
      payload: axios.post(`analytics_item_views`,params)
    })
  }
}




// WEBPACK FOOTER //
// ./src/actions/AnalyticsItemViewActions.js